export default "__VITE_ASSET__BjHWrcVO__"